export interface QuoteClassNames {
  heading: string;
  subHeading: string;
  wrapper: string;
}

export const CLASS_NAMES: QuoteClassNames = {
  heading: 'text-16-20-em mb-2',
  subHeading: 'text-13-14 text-neutral-700 mb-6',
  wrapper: 'flex flex-col mb-12',
};

interface QuoteFieldNames {
  loanAmount: string;
  depositAmount: string;
  editLoanAmount: string;
  editDepositAmount: string;
  duration: string;
  interest: string;
  provider: string;
  error: string;
}

export const FIELD_NAMES: QuoteFieldNames = {
  loanAmount: 'loanAmount',
  depositAmount: 'depositAmount',
  editLoanAmount: 'editLoanAmount',
  editDepositAmount: 'editDepositAmount',
  duration: 'duration',
  interest: 'interest',
  provider: 'provider',
  error: 'error',
};
